Ext.ns('mx.plugin');

/*
 * config format:
 {
 paramName: <http request parameter name to be sent to server (default 'query')>
 linkField: <field name of the independent combobox (default 'id')>
 }
 *
 * Both comboboxes should define property 'dependency'. Possible values: 'independent' and 'dependent'
 *
 * */
mx.plugin.Dependent = function(/*Object config*/ config) {
    this.paramName = 'query';
    this.linkField = 'id';
    Ext.apply(this, config);
};

Ext.extend(mx.plugin.Dependent, Ext.util.Observable, {
    init: function(/*Ext.form.Combobox*/ combo) {
        if (combo.dependency == 'independent') {
            this.independent = combo;
        } else if (combo.dependency == 'dependent') {
            this.dependent = combo;
        }

        if (this.dependent && this.independent) {
            this.independent.on(
                'change',
                function(field, value) {
                    this.addParamValue(value);
                    this.dependent.store.reload();
                    if (this.dependent.el) {
                        this.dependent.clearValue();
                    }
                },
                this
            );

            this.independent.on('setvalue', this.addParamValue, this);
        }
    },

    addParamValue: function(value) {
        if (value) {
            if (typeof value.splice == 'function' && value.length) {
                value = value[0];
            }
            if (value.get) {
                this.dependent.store.baseParams[this.paramName] = value.get(this.linkField);
            }
        }
    },
});
